export const truncateText = (
  text: string,
  length = 30,
  lang = 'ar',
  isRtl?: boolean
): string => {
  if (text.length <= length) return text;
  return lang === 'ar'
    ? isRtl
      ? `${text.slice(0, length)}...`
      : `...${text.slice(0, length)}`
    : `${text.slice(0, length)}...`;
};
